import "./core.js";

import { createApp } from 'vue/dist/vue.esm-bundler';


import Test from "./Test";

//Nette
import {reactive, toRefs} from "vue";

//Components
import Home from "./components/Home";
import FlashMessage from "./components/FlashMessage";
import RegisteredOnCourse from "./components/RegisteredOnCourse.vue";

window.xhrLink = '/xhr/';

export const app = createApp({
	setup() {
		const data = reactive({
		});

		return {
			...toRefs(data)
		}
	}
})
	.component(Home.name, Home)
	.component(Test.name, Test)
	.component(FlashMessage.name, FlashMessage)
	.component(RegisteredOnCourse.name, RegisteredOnCourse)
	.mount('#app');
